import fallbackData from '../../../config/admin/fallbackData';

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = {
  user: {
    // Default to all product access
    productAccess: JSON.parse(sessionStorage.getItem('productAccess')) || fallbackData.userData.productAccess,
    username: 'Username unknown',
    userAgency: 'User agency unknown',
  },
};

const getters = {
  user(state) {
    return state.user;
  },
};

const mutations = {
  updateUserData(state, newUserData) {
    const productAccess = (
      Array.isArray(newUserData.Products) && newUserData.Products.length ? newUserData.Products.map(product => product.ProductId) : null
    );
    state.user.productAccess = productAccess || state.user.productAccess;
    state.user.username = newUserData.username || state.user.username;
    state.user.userAgency = newUserData.userAgency || state.user.userAgency;
    // Also store value in session storage to be used if app is reloaded
    sessionStorage.setItem('productAccess', JSON.stringify(state.user.productAccess));
  },
};

const actions = {
  updateUserData({ commit }, newUserData) {
    commit('updateUserData', newUserData);
  },
};

/**
 * export module to main store.js
 */
export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js